import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStore } from '../../features/login/store/auth.store';

export const httpRequestsInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthStore);

  const modifiedReq = req.clone({
    setHeaders: auth.token()
      ? {
          Authorization: `Bearer ${auth.token!()}`,
          'Content-Type': 'application/json',
        }
      : {
          'Content-Type': 'application/json',
        },
  });

  return next(modifiedReq);
};
